import React from "react";
import LoadingSpinner from "../../components/LoadingSpinner.jsx";

const LoadingExportsView = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        paddingTop: 60,
      }}
    >
      <div style={{ height: 70 }}>
        <LoadingSpinner />
      </div>
      <div>Loading</div>
    </div>
  );
};

export default LoadingExportsView;
